<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton @onClick="$router.back()" chevronLeft>Retour</SportipsButton>
                        </div>
                        <div class="d-flex flex-column ga-2">
                            <div class="text-h5 font-weight-bold text-darkblue">Créer une liste de contacts
                            </div>
                            <div>Cette interface vous permet de créer une liste de contacts pour les campagnes d'emails.
                            </div>
                            <TheFilters></TheFilters>
                            <div v-if="hasFilteredInscriptionsList" class="d-flex justify-center my-2">
                                <SportipsButton @onClick="openDialog" chevron icon="mdi-file-export">
                                    Créer la liste ({{ filteredInscriptionsList.length }} contacts)
                                </SportipsButton>
                            </div>
                            <ListContacts v-if="filteredInscriptionsList != null" :contacts="filteredInscriptionsList"
                                class="spo-card rounded bordered pa-2">
                            </ListContacts>

                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <!-- Dialog pour créer la liste -->
        <CreateListDialog v-model="showDialog"
            :contacts-count="filteredInscriptionsList ? filteredInscriptionsList.length : 0"
            @confirm="handleCreateList" />
    </div>
</template>

<script>
import TheFilters from "@/components/Administration/MailingSystem/CreateContactListing/TheFilters.vue";
import ListContacts from "@/components/Administration/MailingSystem/CreateContactListing/ListContacts.vue";
import CreateListDialog from "@/components/Administration/MailingSystem/CreateContactListing/CreateListDialog.vue";
import { useMailingSystemStore } from "@/stores/mailingSystem/mailingSystemStore";
import { mapStores } from "pinia";
export default {
    components: { TheFilters, ListContacts, CreateListDialog },
    data() {
        return {
            showDialog: false
        }
    },
    computed: {
        ...mapStores(useMailingSystemStore),
        filteredInscriptionsList() {
            return this.mailingSystemStore.filteredInscriptionsList;
        },
        hasFilteredInscriptionsList() {
            return this.filteredInscriptionsList != null && this.filteredInscriptionsList.length > 0;
        }
    },
    methods: {
        openDialog() {
            this.showDialog = true;
        },
        handleCreateList(listName) {
            console.log('Créer la liste avec le nom:', listName);
            console.log('Nombre de contacts:', this.filteredInscriptionsList.length);
            console.log('Contacts:', this.filteredInscriptionsList);

            // TODO: Implémenter la logique de création de la liste
            this.showDialog = false;
            let response = this.mailingSystemStore.createContactList(listName, this.filteredInscriptionsList);
            if (response) {
                this.mainStore.notification.send("Liste créée avec succès", "success");
                this.$router.push({ name: "MailingSystem" });
            } else {
                this.mainStore.notification.send("Erreur lors de la création de la liste", "error");
            }


        }
    }
}

</script>

<style lang="scss" scoped></style>